import { render, staticRenderFns } from "./licenseedit.vue?vue&type=template&id=542a92c4&scoped=true&"
import script from "./licenseedit.vue?vue&type=script&lang=js&"
export * from "./licenseedit.vue?vue&type=script&lang=js&"
import style0 from "./licenseedit.vue?vue&type=style&index=0&id=542a92c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542a92c4",
  null
  
)

export default component.exports